import React, { useEffect, useState } from "react";

const UserInput = ({
  labelName,
  dataKey,
  typeName,
  inputData,
  changeUserData,
  isRequired,
  setIsRequired,
}) => {
  const [isFilled, setIsFilled] = useState(false);
  const [input, setInput] = useState("MockData");
  const [isError, setIsError] = useState(false);

  useEffect(() => {
    changeUserData(dataKey, input);
  }, []);

  useEffect(() => {
    if (isRequired) {
      if (input !== "") {
        setIsError(false);
      } else {
        setIsError(true);
      }
    }
  }, [isRequired, input]);

  useEffect(() => {
    if (input !== "") {
      setIsFilled(true);
    } else {
      setIsFilled(false);
    }
  }, [input]);

  const changeInputHandler = (e) => {
    setInput(e.target.value);
    changeUserData(dataKey, e.target.value);
  };

  const focusedInputHandler = () => {
    setIsFilled(true);
  };

  return (
    <>
      <div className="interface-form_group">
        {typeName === "textarea" ? (
          <>
            <textarea
              className={
                isFilled ? "interface_input active-input" : "interface_input"
              }
              onChange={(e) => changeInputHandler(e)}
              value={input}
              name={dataKey}
              onFocus={focusedInputHandler}
            ></textarea>
            <label
              htmlFor=""
              className={
                isFilled
                  ? "interface-form_label interface_input__focused"
                  : "interface-form_label"
              }
            >
              Сообщение
            </label>
          </>
        ) : (
          <>
            <input
              className={`interface_input ${isFilled ? `active-input` : ``} ${
                isError ? `error-input` : ``
              }`}
              onChange={(e) => changeInputHandler(e)}
              required
              value={input}
              name={dataKey}
              type={typeName ? typeName : "text"}
              onFocus={focusedInputHandler}
            />
            <label
              htmlFor=""
              className={
                isFilled
                  ? "interface-form_label interface_input__focused"
                  : "interface-form_label"
              }
            >
              {labelName ? labelName : ""}
            </label>
            {isError && isRequired ? (
              <span className="interface-error_text">
                Это поле обязательно для заполнения.
              </span>
            ) : null}
          </>
        )}
      </div>
    </>
  );
};

export default UserInput;
